import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import CustomFieldValuesCollection from 'modules/custom_resources/store/collections/customFields/values'
import CustomField from 'modules/custom_resources/store/models/customFields/Field'

export interface CustomFieldValuesContractData {
  loading: boolean
  customFieldValues: CustomFieldValuesCollection
}

const useFetchCustomFieldValues = (contractVersionIds: string[]): CustomFieldValuesContractData => {
  const customFieldValues = useLazyRef(
    () =>
      new CustomFieldValuesCollection([], {
        model_ref: 'Contracts::ContractVersion',
      })
  ).current
  const { loading } = useAsyncData(async () => {
    return Promise.all([
      customFieldValues.fetch({
        data: {
          usage_group_slug: [CustomField.UsageGroups.contractVersions],
          instance_ids: contractVersionIds,
        },
      }),
    ])
  }, [contractVersionIds.join()])

  return {
    loading,
    customFieldValues,
  }
}

export default useFetchCustomFieldValues
